module.exports = __webpack_public_path__ + "static/media/centrofarma_sigin.c2ce820e.jpg";